export const ANALYTICS_CHANNEL = 'peopleTeams';
